<template>
    <v-app style="min-height: 50vh">
        <div style="margin-top:50px"></div>
        <v-img :src="$vuetify.theme.dark ? '/assets/img/footer_bg_dark.jpg' : '/assets/img/footer_bg.jpg'" position="49% center" cover>
            <div class="fill-height mask_grad2 messiri_fonted">

                <v-img :src="$vuetify.theme.dark ? '/assets/img/footer_logo_dark.svg' : '/assets/img/footer_logo2.svg'" height="65" class="mx-auto" width="319"></v-img>
                <!-- <div v-else class="footer_logo mx-auto"> <svg viewBox="0 0 319 65"><use xlink:href="/assets/img/footer_logo2.svg#view"></use></svg></div> -->

                <div class="footer_desc mt-3 text-center"> {{$t('alkafeel_title')}}  - {{ $t('alkafeel_desc') }}</div>

                <div class="social_wrap mt-4">

                    <a v-if="$i18n.locale !== 'pr'" :href="$store.state.social.fb" target="_blank"><div class="social_icon2"> <svg viewBox="0 0 25 25"><use xlink:href="/assets/img/social/Facebook_black.svg#view"></use></svg></div></a>
                    <a v-else :href="$store.state.social.fb" target="_blank"><div class="social_icon2"> <svg viewBox="0 0 25 25"><use xlink:href="/assets/img/social/eitaa_black.svg?#view"></use></svg></div></a>
                    <a :href="$store.state.social.twtr" target="_blank"><div class="social_icon2"> <svg viewBox="0 0 25 25"><use xlink:href="/assets/img/social/X_black.svg#view"></use></svg></div></a>
                    <a :href="$store.state.social.inst" target="_blank"><div class="social_icon2"> <svg viewBox="0 0 25 25"><use xlink:href="/assets/img/social/Instagram_black.svg#view"></use></svg></div></a>
                    <a :href="$store.state.social.tlg" target="_blank"><div class="social_icon2"> <svg viewBox="0 0 25 25"><use xlink:href="/assets/img/social/Telegram_black.svg#view"></use></svg></div></a>
                    <a :href="$store.state.social.yt" v-if="$i18n.locale !== 'pr'" target="_blank"><div class="social_icon2"> <svg viewBox="0 0 25 25"><use xlink:href="/assets/img/social/Youtube_black.svg#view"></use></svg></div></a>
                    <a :href="$store.state.social.yt" v-else target="_blank"><div class="social_icon2"> <svg viewBox="0 0 25 25"><use xlink:href="/assets/img/social/Aparat_black.svg#view"></use></svg></div></a>
                    <a :href="$store.state.social.tk" target="_blank"><div class="social_icon2"> <svg viewBox="0 0 25 25"><use xlink:href="/assets/img/social/Tiktok_black.svg#view"></use></svg></div></a>
                    
                    
                </div>
                


                <v-layout row text-center mt-4 mb-10>
                    <v-flex lg4 md6 sm6 xs6 mt-6 class="messiri_fonted">
                        <v-layout row>
                            <v-flex lg6 class="hidden-sm-and-down">
                                
                                <template v-if="$store.state.navigation[3].sub">
                                    
                                    <div class="footer_title"><span class="border-b">{{$t($store.state.navigation[3].word)}}</span></div>
                                    
                                    <template v-for="item in JSON.parse($store.state.navigation[3].sub).slice(0,5)">
                                        <div :key="item" v-if="item.visible == 1">

                                            <template v-if="!item.router">
                                                <a class="social_text" :href="item.url+'?lang='+$i18n.locale" target="_blank">{{$t(item.word)}}</a>
                                            </template>
                                            <template v-else>
                                                <router-link class="social_text" :to="item.to+'?lang='+$i18n.locale" >{{$t(item.word)}}</router-link>
                                            </template>

                                        </div>
                                    </template>
                                </template>

                            </v-flex>
                            <v-flex lg6>

                                <!-- 
                                <div class="footer_title"><span>{{$t('zaer_services')}}</span></div>

                                <div><a class="social_text" :href="'https://alkafeel.net/zyara/?lang='+$i18n.locale" target="_blank">{{$t('index_zyara')}}</a></div>
                                <div><a class="social_text" :href="'https://alkafeel.net/message/?lang='+$i18n.locale" target="_blank">{{$t('msg_message_to_shrine')}}</a></div>
                                <div><a class="social_text" :href="'https://alkafeel.net/panorama/?lang='+$i18n.locale" target="_blank">{{$t('index_panorama')}}</a></div>
                                <div><a class="social_text" :href="'https://alkafeel.net/lost/?lang='+$i18n.locale" target="_blank">{{$t('index_lost')}}</a></div>
                                <div><router-link class="social_text" :to="'/stream?lang='+$i18n.locale" >{{$t('index_live')}}</router-link></div> -->

                                <template v-if="$store.state.navigation[2].sub">
                                    
                                    <div class="footer_title"><span class="border-b">{{$t($store.state.navigation[2].word)}}</span></div>
                                    
                                    <template v-for="item in JSON.parse($store.state.navigation[2].sub).slice(0,5)">
                                        <div :key="item" v-if="item.visible == 1">

                                            <template v-if="!item.router">
                                                <a class="social_text" :href="item.url+'?lang='+$i18n.locale" target="_blank">{{$t(item.word)}}</a>
                                            </template>
                                            <template v-else>
                                                <router-link class="social_text" :to="item.to+'?lang='+$i18n.locale" >{{$t(item.word)}}</router-link>
                                            </template>

                                        </div>
                                    </template>
                                </template>

                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex lg4 class="hidden-md-and-down"></v-flex>

                    <v-flex lg4 md6 sm6 xs6 mt-6 class="messiri_fonted">
                        <v-layout row>
                            <v-flex lg6>
                                
                                <div class="footer_title"><span class="border-b"> {{$t('atabat_websites')}} </span></div>
                                
                                <div v-for="ataba in atabat" :key="ataba">
                                    <a class="social_text" :href="ataba['url']" target="_blank">{{$t(ataba['word'])}}</a>
                                </div>
                            </v-flex>

                            <v-flex lg6 class="hidden-sm-and-down" v-if="$i18n.locale=='ar'">
                                <!-- <template v-for="(t, i) in JSON.parse($store.state.navigation[3].sub)" >
                                    <div v-if="i == 5">{{ t.title }}</div>
                                </template> -->
                                <template v-if="$store.state.navigation[3].sub">

                                    <template v-for="(t, i) in JSON.parse($store.state.navigation[3].sub)" >
                                        <div class="footer_title" v-if="i == 5"><span class="border-b">{{ t.title }}</span></div>
                                    
                                        <template v-if="i == 5" v-for="(item, index) in t.sub">
                                            <div v-if="item.visible == 1 && index < 5" :key="item">
                                                <a class="social_text" :href="item.url" target="_blank">{{item.title}}</a>
                                            </div>
                                        </template>
                                    </template>

                                </template>
                            </v-flex>
                            <v-flex v-else lg6 class="hidden-sm-and-down" >
                                <!-- 
                                <div class="footer_title"><span>{{$t('index_imam_abbas')}}</span></div>

                                    <div><router-link class="social_text" :to="'/abbas?lang='+$i18n.locale" >{{$t('index_abbas')}}</router-link></div>
                                    <div><router-link class="social_text" :to="'/history?lang='+$i18n.locale" >{{$t('index_histroy')}}</router-link></div>
                                    <div><router-link class="social_text" :to="'/description?lang='+$i18n.locale" >{{$t('index_desc')}}</router-link></div> -->

                                    <template v-if="$store.state.navigation[0].sub">
                                    
                                    <div class="footer_title"><span>{{$t($store.state.navigation[0].word)}}</span></div>
                                    
                                    <template v-for="item in JSON.parse($store.state.navigation[0].sub).slice(0,5)">
                                        <div :key="item" v-if="item.visible == 1">

                                            <template v-if="!item.router">
                                                <a class="social_text" :href="item.url+'?lang='+$i18n.locale" target="_blank">{{$t(item.word)}}</a>
                                            </template>
                                            <template v-else>
                                                <router-link class="social_text" :to="item.to+'?lang='+$i18n.locale" >{{$t(item.word)}}</router-link>
                                            </template>

                                        </div>
                                    </template>
                                </template>

                            </v-flex>

                        </v-layout>
                    </v-flex>
                </v-layout>
                
                <v-layout justify-center class="copy_right">{{$t('index_copyright')}}</v-layout>
            </div>
        </v-img>
    </v-app>
</template>

<script>
// import axios from "axios";

export default {
    data() {
        return {
            atabat: [],

        }
    },
    created () {
        this.initialize();
    },

      mounted() {
        // this.lang_dt(this.$route.query.lang);
    //         const theme = localStorage.getItem("dark_theme");
    // if (theme) {
    //     if (theme === "true") {
    //         this.$vuetify.theme.dark = true;
    //     } else {
    //         this.$vuetify.theme.dark = false;
    //     }
    // } else if (
    //     window.matchMedia &&
    //     window.matchMedia("(prefers-color-scheme: dark)").matches
    // ) {
    //     this.$vuetify.theme.dark = true;
    //     localStorage.setItem(
    //         "dark_theme",
    //         this.$vuetify.theme.dark.toString()
    //     );
    // }

    },

    methods:{
        //    toggle_dark_mode: function() {
        // this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        // localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());

        //    },
        initialize() {
            this.$axios.get("https://alkafeel.net/main_bg/data/atabat_main.json")
            .then(respons => {
                this.atabat = respons.data;
                // console.log(respons.data);
                // console.log(this.$store.state.navigation[1].title);
            })
            .catch(errors => {
                console.error(errors);
            });
        },
    }
}
</script>

<style scoped>
    ::v-deep .v-application--wrap {
        min-height: 70vh!important;
    }
    .footer_logo {
        width: 319px;
        height: 65px;
        fill: #C19A6C;
    }
    .social_wrap {
        text-align: center;
    }
    .copy_right {
        color: white;
        position: absolute;
        bottom: 10px;
        right: 0;
        left: 0;
    }
    .social_text {
        display: inline-block;
        text-decoration: none;
        color: #0A142F;
        line-height: 50px;
        font-size: 14px;
        font-weight: 500;
    }
    .social_icon {
        vertical-align: middle;
    }
    .social_icon2 {
        fill:#4F4F4F;
        width: 24px;
        height: 24px;
        margin: 15px 10px;
        display: inline-block;
    }
    .footer_title {
        font-size: 16px;
        color: #0A142F;
        margin-bottom: 16px;
    }
    .mask_grad2 {
        padding: 5%;
        background-image:linear-gradient(to bottom, rgba(255,255,255, 1) 0%, rgba(255,255,255, .8) 20%, rgba(255,255,255, .7) 40%, transparent 60%, transparent 80%, rgba(0,0,0, .8) 100%), url('data:image/png;base64,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');
        background-repeat: repeat;
    }

    .border-b {
        border-bottom: 2px solid #b1bd52;
        font-weight: bold;
        font-size: 16px;
    }
</style>